import { render } from "./EdiClaimPreviewOffcanvas.vue?vue&type=template&id=7bbae6dc&scoped=true"
import script from "./EdiClaimPreviewOffcanvas.vue?vue&type=script&lang=js"
export * from "./EdiClaimPreviewOffcanvas.vue?vue&type=script&lang=js"

import "./EdiClaimPreviewOffcanvas.vue?vue&type=style&index=0&id=7bbae6dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bbae6dc"]])

export default __exports__